module.exports = __webpack_public_path__ + "static/media/cS-1.c32ef004.jpg";